import {createContext, Dispatch} from 'react';

type initialStateType = {
    _id:string
}

type ModalPartial = {
    state:initialStateType,
    dispatch: Dispatch<any>
}

export const initialState = {
    _id: ''    
}

export enum Types {
    GET_INFO_PERFORMANCE_EVAL = "GET_INFO_PERFORMANCE_EVAL",     
}


const ModalInitialState = {
    state:initialState,
    dispatch:() => null
}

const PerformanceEvaluationResultsContext = createContext<ModalPartial>(ModalInitialState)

export default PerformanceEvaluationResultsContext; 

